import $ from 'jquery';
import { getOptionsFromDataset } from '../../util/dom.js';
// import Autocomplete from '../../mpro/plugins/jquery.autocomplete';

/**
 * @typedef {import('../../mpro/plugins/jquery.autocomplete').default} Autocomplete
 * @typedef {import('../../mpro/plugins/jquery.autocomplete').AutocompleteOptions} AutocompleteOptions
 */

/**
 * @type {AutocompleteOptions}
 */
// @ts-ignore
const autocompleteDefaults = {
	searchOnInit: false,
	minChars: 1,
	delay: 366,
	sgWidth: 'auto',
	selectFirst: true,
	termReplaceRules: mpro.getRegexAutocompleteTerm,

	/** @type {(this: Autocomplete) => void} */
	onInit() {
		const that = this;
		// Add ref to the clear button
		that.refs.$btnClear = that.refs.$input.siblings('.search-clear');
		// Add binding to the clear button
		that.refs.$btnClear.on('click', (e) => {
			that.refs.$input.val('').trigger('change');
		});
	},

	/** @type {(this: Autocomplete, items: any[]) => boolean|void} */
	// onSearchSuggest: function (items) {
	// 	if (!items || !items.length) {
	// 		this.searchSuggest({}, {
	// 			term: this.lastSearch.term,
	// 			items: [{
	// 				id: 0,
	// 				text: JS_LANG_VARS.txt_no_results,
	// 				addClass: 'p-05 text-center',
	// 				selectable: false
	// 			}]
	// 		});
	// 		return false;
	// 	}
	// },

	/** @type {(this: Autocomplete, $item: JQuery, originalEvent: JQuery.Event) => boolean|void} */
	onSelectItem($item) {
		const itemData = $item.data();
		if (itemData) {
			if (itemData.link) {
				mpro.setLocation(itemData.link);
				this.destroy();
				return false;
			}
		}
	},

	/** @type {(this: Autocomplete, xhr: JQuery.jqXHR) => boolean|void} */
	onXhrStart() {
		this.refs.$input.addClass('ac-loading');
	},

	/** @type {(this: Autocomplete, dataOrXhr: any|JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string|JQuery.jqXHR) => boolean|void} */
	onXhrComplete() {
		this.refs.$input.removeClass('ac-loading');
	},
};

/**
 * Static plugin binding
 */
// $.Autocomplete = Autocomplete;

// Create a jQuery plugin
// ======================
// $.fn.autocomplete = function (options) {
// 	return this.each(function () {
// 		new Autocomplete(this, options);
// 	});
// };

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	// Find elements that require the plugin
	/** @type {JQuery<HTMLInputElement>} */
	// @ts-ignore
	const $collection = $container.find('input[data-autocomplete-url]');

	if ($collection.length > 0) {

		// Lazy import the plugin
		const { 'default': Autocomplete } = await import('../../mpro/plugins/jquery.autocomplete.js');

		// Apply the plugin to every element
		$collection.each(function() {

			// Only if not already initialized
			if (!Autocomplete.getInstance(this)) {

				const $elem = $(this);
				const data = getOptionsFromDataset(this, 'autocomplete', true);
				const autocompleteArgs = data.args || null;
				delete data.args;

				/** @type {Map<string, JQuery|string>} */
				const acParams = new Map;

				if (autocompleteArgs) {
					for (const [field, elementId] of Object.entries(autocompleteArgs)) {

						// 'fields' is a special parameter, no selector, send as is
						if (field === 'fields') {
							acParams.set(field, elementId);
						}
						else {
							acParams.set(field, $(`#${elementId}`));
						}
					}
				}

				Autocomplete.create(this, {
					...autocompleteDefaults,
					...data,
					remote: {
						url: data.url,
						/** @type {(term: string) => {[key: string]: string}|{}} */
						data(term) {
							if (acParams.size > 0) {
								const data = {};

								// Map field ids to their values
								for (const [field, $elem] of acParams) {
									// Computed value
									if ($elem instanceof $) {
										// @ts-ignore
										const val = $elem.val();
										if (val !== '' && val != null) {
											data[field] = val;
										}
									}
									// Hardcoded value
									else {
										data[field] = $elem;
									}
								}
								return data;
							}
							return { q: term };
						},
						method: 'GET',
					},
				});

				// @ts-ignore
				$elem.on('destroy', () => {
					acParams.clear();
				});
			}
		});
	}
});
